export const emailRegex =
  /(?!.*\.{2})^([a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i; // eslint-disable-line
export const validFiles = /^[^.]+.(jpg|png|gif|doc|docx|pdf|pptx|txt|xls|xlsx|ppt)$/i;
export const whitespaceRegex = /[\t\v\f\r \u00a0\u2000-\u200b\u2028-\u2029\u3000]+/g; // excluding newlines

/**
 * Escapes special chars from string
 * @param {str}
 */
export const escapeQuery = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Generate a pseudo-full-text regular expression from a search query (useful for basic searches)
 * @param {string} q
 */
export const getFullTextSearchRegex = (q: string): RegExp => {
  const words = q.trim().split(/\s+/);
  const pattern = words.map(word => escapeQuery(word)).join('|');
  return new RegExp(pattern, 'i');
};

/**
 * Checks if a string is a valid base64 encoded string
 * @param {string} str
 * @returns {boolean}
 */
export function isValidBase64(str: string): boolean {
  const base64RegExp = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  return str.length > 0 && base64RegExp.test(str);
}
